import React, { useEffect, useRef, useState } from "react";
import type { ColumnType, ColumnsType } from "antd/es/table";
import {
  Alert,
  Button,
  Col,
  Empty,
  Flex,
  Input,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import type { InputRef } from "antd";
import PaidIcon from "@mui/icons-material/Paid";
import SellIcon from "@mui/icons-material/Sell";
import type { FilterConfirmProps, FilterValue } from "antd/es/table/interface";
import CancelIcon from "@mui/icons-material/Cancel";
import VerifiedIcon from "@mui/icons-material/Verified";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Dropdown, message } from "antd";
import { ArrowsAltOutlined, SearchOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import Highlighter from "react-highlight-words";
import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Skeleton } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import styled from "styled-components";
import axios from "axios";
import HomeIcon from "@mui/icons-material/Home";
import Globais, {
  formatarData,
  logout,
  validateToken,
  venderCota,
} from "../../components/Globais";
import {
  verificarSeTemPeriodoUsuario,
  verificarSeTemPeriodoUsuarioDefinido,
} from "../../uteis/periodoUsuario/Globais";
import { buscarTodosOsRepresentantesCotaUsuario } from "../../uteis/representante/Globais";
import {
  verificarCTUChecada,
  atualizarCotaUsuarioGlobais,
  regularizarSituacaoCTU,
  verificarPagamentoPorStatus,
  verificarSeMaisInformacoesAnuncioEstaoAusentes,
} from "../../uteis/cotaUsuario/Globais";
import { useQueryParams, StringParam } from "use-query-params";
import { criarAssinaturaCTU } from "../../uteis/assinatura/Globais";
import { useMediaQuery } from "react-responsive";

import ModalAcoes from "./components/ModalAcoes";
import { BotoesAcoes, Container, ContainerItems, Icon, Items } from "./styles";
import { useNavigate } from "react-router-dom";
import { cadastroCotaUsuarioApi } from "../cadastroPropriedadeV2/cadastroCotaUsuario.api";

import { combinarPropriedadesECadastros, PropriedadeListada } from "./listagemCadastros";

type DataType = PropriedadeListada;

type DataIndex = keyof DataType;
type MenuItem = Required<MenuProps>["items"][number];

export default function ViewCadastroCotas() {
  const [visualizacaoCotas, setVisualizarCotas] = useState<DataType[]>([]);
  const [erroCarregamento, setErroCarregamento] = useState<string | null>(null);
  const searchInput = useRef<InputRef>(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const periodoUsuario = useRef(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const emLote = useRef(0);
  const [isLoading, setIsLoading] = useState(true);
  const { Title } = Typography;
  const [statusParam, setStatusParam] = useQueryParams({ status: StringParam });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isDesktop = useMediaQuery({ query: "(min-width: 769px)" });

  const cotaUsuarioId = useRef(0);
  const usuarioLogadoId = useRef(0);

  const numeroCota = useRef(0);
  const empreend = useRef("");
  const status = useRef("");

  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchStatus = async () => {
      const Token = validateToken();

      const regularizarCTUs = (response: any, responseRepresentantes: any) => {
        response.data.map(async (p: any) => {
          switch (p.status) {
            case "AGUARDANDO_PERIODOS":
              regularizarSituacaoCTU(p.id, "AGUARDANDO_PERIODOS");
              break;
            case "AGUARDANDO_DEFINICAO_PERIODOS":
              regularizarSituacaoCTU(p.id, "AGUARDANDO_DEFINICAO_PERIODOS");
              break;
            default:
              regularizarSituacaoCTU(p.id, p.status);
          }
        });

        responseRepresentantes.data.map(async (q: any) => {
          switch (q.CotasUsuariosTable.status) {
            case "AGUARDANDO_PERIODOS":
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                "AGUARDANDO_PERIODOS"
              );

              break;
            case "AGUARDANDO_DEFINICAO_PERIODOS":
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                "AGUARDANDO_DEFINICAO_PERIODOS"
              );

              break;
            default:
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                q.CotasUsuariosTable.status
              );
          }
        });

      };

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/0`;
        const URLRepresentantes = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          const responseRepresentantes = await axios.get(URLRepresentantes, {
            headers: { Authorization: Token.AuthStr },
          });

          if (statusParam.status === "AGUARDANDO_MAISINFO_ANUNCIO") {
            let CTUId = "";
            let dataUpdated = "";
            let resultado1;
            let resultado2;

            // procurar CTU no status AGUARDANDO_MAISINFO_ANUNCIO mais recente
            if (response && responseRepresentantes) {
              if (response.data.length > 0) {
                resultado1 = response.data.map((p: any) => {
                  if (p.status === "AGUARDANDO_MAISINFO_ANUNCIO") {
                    if (dataUpdated === "" || p.updated_at > dataUpdated) {
                      dataUpdated = p.updated_at;
                      CTUId = p.id;
                    }
                  }
                });
              }
              if (responseRepresentantes.data.length > 0) {
                resultado2 = responseRepresentantes.data.map((p: any) => {
                  if (
                    p.CotasUsuariosTable.status ===
                    "AGUARDANDO_MAISINFO_ANUNCIO"
                  ) {
                    if (
                      dataUpdated === "" ||
                      p.CotasUsuariosTable.updated_at > dataUpdated
                    ) {
                      dataUpdated = p.CotasUsuariosTable.updated_at;
                      CTUId = p.CotasUsuariosTable.id;
                    }
                  }
                });
              }
              if ((await resultado1) || (await resultado2)) {
                if (CTUId !== "") {
                  await abrirDetalhesDaPropriedade(Number(CTUId));
                } else {
                  regularizarCTUs(response, responseRepresentantes);
                }
              }
            } else {
              console.log("Erro ao buscar propriedades do usuário");
            }
          } else {
            if (response && responseRepresentantes) {
              regularizarCTUs(response, responseRepresentantes);
            } else {
              console.log("Erro ao buscar propriedades do usuário");
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        document.location.href = "/login";
      }
    };
    fetchStatus();
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      let obj = localStorage.getItem("filtrosCadastroCotas");
      let page = localStorage.getItem("pageCadastroCotas");
      if (obj) {
        let novoFiltro = JSON.parse(obj);

        setFilteredInfo({
          empreend: novoFiltro.empreend,
          nomeCidade: novoFiltro.nomeCidade,
          aptoNome: novoFiltro.aptoNome,
          numeroCota: novoFiltro.numeroCota,
          icone: novoFiltro.icone,
        });
        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/0`;
        const URLRepresentantes = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

        try {
          usuarioLogadoId.current = Token.id;
          const [cotas, representantes, cadastros] = await Promise.allSettled([
            axios.get(URL, { headers: { Authorization: Token.AuthStr } }),
            axios.get(URLRepresentantes, { headers: { Authorization: Token.AuthStr } }),
            cadastroCotaUsuarioApi.buscarEmAndamento(),
          ]);
          const falhas = [cotas, representantes, cadastros].filter(
            (resultado) => resultado.status === "rejected"
          );
          if (falhas.some((resultado) => resultado.status === "rejected" && resultado.reason?.response?.status === 401)) {
            logout();
            return;
          }
          setErroCarregamento(falhas.length
            ? "Não foi possível carregar toda a lista. Atualize a página para tentar novamente."
            : null);
          const response = cotas.status === "fulfilled" ? cotas.value : { data: [] };
          const responseRepresentantes = representantes.status === "fulfilled" ? representantes.value : { data: [] };
          const cadastrosEmAndamento = cadastros.status === "fulfilled" ? cadastros.value : null;

          if (response && responseRepresentantes) {
            // console.log("response.data");

            // console.log(responseRepresentantes.data);

            let ArrayNovo = response.data.map((p: any) => {
              p.key = `cota-${p.id}`;
              p.empreend = p.CotaTable?.AptoTable?.EmpreendimentoTable?.nome || "Não definido";
              p.cidade =
                p.CotaTable?.AptoTable?.EmpreendimentoTable?.CidadeTable?.nome;
              p.estado =
                p.CotaTable?.AptoTable?.EmpreendimentoTable?.CidadeTable?.EstadoTab?.abreviacao;
              p.numeroCota = p.CotaTable?.numeroCota ?? "Não definida";
              p.cotaUsuarioId = p.id;
              p.prioridade = p.prioridade;
              p.cotaId = p.cotaId;
              p.aptoId = p.CotaTable?.AptoTable?.id;
              p.capacidade = p.CotaTable?.AptoTable?.capacidade ?? "Não definida";
              p.aptoNome = p.CotaTable?.AptoTable?.nome || "Não definido";
              p.situacao = "Proprietário";

              if (p.bloco && p.numeroApto) {
                p.infoApt = `${p.bloco} - ${p.numeroApto}`;
              } else {
                p.infoApt = "";
              }

              p.nomeCidade = p.cidade ? [p.cidade, p.estado].filter(Boolean).join(" - ") : "Não definida";

              if (
                p.status === "AGUARDANDO_AUTENTICACAO" ||
                p.status === "AGUARDANDO_APTOMAISINFO" ||
                p.status === "AGUARDANDO_REPRESENTANTE" ||
                p.status === "AGUARDANDO_PROCURACAO" ||
                p.status === "AGUARDANDO_CADASTRO" ||
                p.status === "AGUARDANDO_APTO" ||
                p.status === "AGUARDANDO_TITULARIDADE" ||
                p.status === "AGUARDANDO_COMPROVANTE" ||
                p.status === "AGUARDANDO_COTA" ||
                p.status === "AGUARDANDO_PERIODOS" ||
                p.status === "AGUARDANDO_DEFINICAO_ANUNCIO" ||
                p.status === "AGUARDANDO_MAISINFO_ANUNCIO" ||
                p.status === "AGUARDANDO_DEFINICAO_PERIODOS"
              ) {
                p.icone = "Cadastro pendente";
              } else {
                if (
                  p.status === "AUTENTICADA_NIVEL1" ||
                  p.status === "AUTENTICADA_NIVEL2"
                ) {
                  p.icone = "Autenticada";
                } else {
                  if (p.status === "VENDENDO") {
                    p.icone = "A Venda";
                  } else {
                    if (p.status === "CANCELADA") {
                      p.icone = "Cancelada";
                    } else if (
                      p.status === "VENDIDA_MC" ||
                      p.status === "VENDIDA_PROPRIO"
                    ) {
                      p.icone = "Vendida";
                    } else {
                      if (p.status === "DISTRATO") {
                        p.icone = "Distrato";
                      } else {
                        if (p.status === "AGUARDANDO_PAGAMENTO") {
                          p.icone = "Pendente pagamento";
                        }
                      }
                    }
                  }
                }
              }

              return p;
            });

            if (responseRepresentantes.data) {
              responseRepresentantes.data.filter((r: any) => r.CotasUsuariosTable).forEach((r: any) => {
                r.key = `representante-${r.id}`;
                r.empreend =
                  r.CotasUsuariosTable.CotaTable?.AptoTable?.EmpreendimentoTable?.nome || "Não definido";
                r.cidade =
                  r.CotasUsuariosTable.CotaTable?.AptoTable?.EmpreendimentoTable?.CidadeTable?.nome;
                r.estado =
                  r.CotasUsuariosTable.CotaTable?.AptoTable?.EmpreendimentoTable?.CidadeTable?.EstadoTab?.abreviacao;
                r.numeroCota = r.CotasUsuariosTable.CotaTable?.numeroCota ?? "Não definida";
                r.cotaUsuarioId = r.CotasUsuariosTable.id;
                r.cotaId = r.CotasUsuariosTable.CotaTable?.id;
                r.aptoId = r.CotasUsuariosTable.CotaTable?.AptoTable?.id;
                r.capacidade =
                  r.CotasUsuariosTable.CotaTable?.AptoTable?.capacidade ?? "Não definida";
                r.aptoNome = r.CotasUsuariosTable.CotaTable?.AptoTable?.nome || "Não definido";
                r.created_at = r.CotasUsuariosTable.created_at;
                r.situacao = "Representante";

                if (
                  r.CotasUsuariosTable.bloco &&
                  r.CotasUsuariosTable.numeroApto
                ) {
                  r.infoApt = `${r.CotasUsuariosTable.bloco} - ${r.CotasUsuariosTable.numeroApto}`;
                } else {
                  r.infoApt = "";
                }

                r.nomeCidade = r.cidade ? [r.cidade, r.estado].filter(Boolean).join(" - ") : "Não definida";

                if (
                  r.CotasUsuariosTable.status === "AGUARDANDO_AUTENTICACAO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_APTOMAISINFO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_REPRESENTANTE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_PROCURACAO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_CADASTRO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_APTO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_TITULARIDADE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_COMPROVANTE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_COTA" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_PERIODOS" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_DEFINICAO_ANUNCIO" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_MAISINFO_ANUNCIO" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                ) {
                  r.icone = "Cadastro pendente";
                } else {
                  if (
                    r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL1" ||
                    r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL2"
                  ) {
                    r.icone = "Autenticada";
                  } else {
                    if (r.CotasUsuariosTable.status === "VENDENDO") {
                      r.icone = "A Venda";
                    } else {
                      if (r.CotasUsuariosTable.status === "CANCELADA") {
                        r.icone = "Cancelada";
                      } else if (
                        r.CotasUsuariosTable.status === "VENDIDA_MC" ||
                        r.CotasUsuariosTable.status === "VENDIDA_PROPRIO"
                      ) {
                        r.icone = "Vendida";
                      } else {
                        if (r.CotasUsuariosTable.status === "DISTRATO") {
                          r.icone = "Distrato";
                        } else {
                          if (
                            r.CotasUsuariosTable.status ===
                            "AGUARDANDO_PAGAMENTO"
                          ) {
                            r.icone = "Pendente pagamento";
                          }
                        }
                      }
                    }
                  }
                }

                ArrayNovo.push(r);
              });
            }
            setVisualizarCotas(combinarPropriedadesECadastros(ArrayNovo, cadastrosEmAndamento));
          } else {
            console.log("Erro ao buscar propriedades do usuário");
          }
        } catch (error) {
          if (error?.response?.status === 401) {
            logout();
          } else {
            setErroCarregamento("Não foi possível carregar a lista. Atualize a página para tentar novamente.");
          }
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchToken();
  }, []);

  const info = async () => {
    const URLInfoRepresentante = `${Globais.DOMINIOBACK}/representante/todos/cotausuario/${cotaUsuarioId.current}`;
    const Token = validateToken();

    if (Token) {
      try {
        const responseInfoRepresentante = await axios.get(
          URLInfoRepresentante,
          {
            headers: { Authorization: Token.AuthStr },
          }
        );

        if (responseInfoRepresentante.data.length === 0) {
          warning(
            "Não há representantes. Vamos te levar para a tela de cadastro de representante."
          );
          setTimeout(() => {
            document.location.href = `/cadastroRepresentante/?cotaUsuarioId=${cotaUsuarioId.current}`;
          }, 3000);
        } else {
          let contador = 0;
          let nome;
          let sobrenome;
          let dataAssinatura = "";
          let dataVencimento = "";

          responseInfoRepresentante.data.map((p: any) => {
            if (p.checked === 1) {
              contador = 1;

              nome = p.UsuarioTable.nome;
              sobrenome = p.UsuarioTable.sobrenome;
              dataAssinatura = p.dataAssinatura;
              dataVencimento = p.dataVencimento;
            }
          });
          if (contador > 0) {
            Modal.info({
              title: "Quem está representando?",
              content: (
                <div>
                  <p>Nome: </p>
                  <p>
                    {nome} {sobrenome}
                  </p>
                  <p>Desde: </p>
                  <p>{formatarData(dataAssinatura)}</p>
                  <p>Até: </p>
                  <p>{formatarData(dataVencimento)}</p>
                </div>
              ),
              onOk() {},
            });
          } else {
            warning(
              "Há representantes cadastrados, mas ainda não foram validados. Aguarde que entraremos em contato para prosseguimento."
            );
          }
        }
      } catch (error) {}
    } else {
      document.location.href = "/login";
    }
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      (record[dataIndex] ?? "")
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  // Mantém as ações implementadas no onClick, mas as oculta temporariamente da interface.
  const hiddenActionKeys = ["1", "3", "6"];
  const items: MenuProps["items"] = [
    { key: "7", label: "Anúncio de Venda" },
    { key: "1", label: "Detalhes" },
    { key: "2", label: "Ver períodos" },
    { key: "3", label: "Representante" },
    { key: "4", label: "Meus documentos" },
    { key: "5", label: "Informações úteis" },
    { key: "6", label: "Excluir" },
  ].filter((item) => !hiddenActionKeys.includes(item.key));

  const columns: ColumnsType<DataType> = [
    {
      title: "Empreendimento",
      dataIndex: "empreend",
      key: "empreend",
      width: "25%",
      filteredValue: filteredInfo.empreend,
      ...getColumnSearchProps("empreend"),
      sorter: (a, b) => a.empreend.length - b.empreend.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Cidade",
      dataIndex: "nomeCidade",
      key: "nomeCidade",
      width: "20%",
      filteredValue: filteredInfo.nomeCidade,
      ...getColumnSearchProps("nomeCidade"),
    },
    {
      title: "Nº Cota",
      dataIndex: "numeroCota",
      key: "numeroCota",
      width: "5%",
      filteredValue: filteredInfo.numeroCota,
      ...getColumnSearchProps("numeroCota"),
    },
    {
      title: "Apartamento",
      dataIndex: "aptoNome",
      key: "aptoNome",
      width: "20%",
      filteredValue: filteredInfo.aptoNome,
      ...getColumnSearchProps("aptoNome"),
    },
    {
      title: "Data de cadastro",
      dataIndex: "created_at",
      key: "created_at",
      width: "15%",
      align: "center",
      render: (data: string | null) => data ? formatarData(data) : "Não definida",
      sorter: (a, b) => (a.created_at || "").localeCompare(b.created_at || ""),
    },
    {
      title: "Status",
      dataIndex: "icone",
      key: "icone",
      width: "5%",
      filters: [
        { text: "Cadastro em andamento", value: "Cadastro em andamento" },
        { text: "Cadastro concluído", value: "Cadastro concluído" },
        { text: "Cadastro pendente", value: "Cadastro pendente" },
        { text: "Anúncio pendente pagamento ", value: "Pendente pagamento" },

        { text: "Autenticada", value: "Autenticada" },
        { text: "A Venda", value: "A Venda" },

        { text: "Vendida", value: "Vendida" },
        { text: "Cancelada", value: "Cancelada" },
        { text: "Distrato", value: "Distrato" },
      ],
      filteredValue: filteredInfo.icone,

      onFilter: (value: any, record) => record.icone.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.cadastroCotaUsuarioId ? (
          <Tooltip title="Cadastro em andamento">
            <PendingActionsIcon color="warning" aria-label="Cadastro em andamento" />
          </Tooltip>
        ) : row.icone === "Cadastro concluído" ? (
          <Tooltip title="Cadastro concluído">
            <TaskAltIcon color="success" aria-label="Cadastro concluído" />
          </Tooltip>
        ) : row.icone === "Cadastro pendente" ? (
          <Tooltip title='Ainda há pendências no cadastro de sua propriedade. Favor clicar em "Detalhes" para continuar.'>
            <PendingActionsIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Autenticada" ? (
          <Tooltip title="Tudo certo! Propriedade autenticada.">
            <VerifiedIcon color="success" />
          </Tooltip>
        ) : row.icone === "Cancelada" ? (
          <Tooltip title="Propriedade cancelada">
            <CancelIcon color="error" />
          </Tooltip>
        ) : row.icone === "A Venda" ? (
          <Tooltip title="Essa propriedade está sendo anunciada.">
            <SellIcon color="warning" />
          </Tooltip>
        ) : row.icone === "Vendida" ? (
          <Tooltip title="Essa propriedade já foi vendida.">
            <PaidIcon color="success" />
          </Tooltip>
        ) : row.icone === "Distrato" ? (
          <Tooltip title="Distrato">
            <NotInterestedIcon color="error" />
          </Tooltip>
        ) : row.icone === "Pendente pagamento" ? (
          <Tooltip title="Anúncio pendente pagamento">
            <MoneyOffIcon color="error" />
          </Tooltip>
        ) : null,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",

      render: (item, row) => row.cadastroCotaUsuarioId ? (
        <Button type="link" onClick={() => navigate(`/cadastroPropriedade/${row.cadastroCotaUsuarioId}`)}>
          Continuar cadastro
        </Button>
      ) : (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                empreend.current = row.empreend;
                cotaUsuarioId.current = row.cotaUsuarioId ?? 0;

                numeroCota.current = Number(row.numeroCota) || 0;
                status.current = row.status;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
  const venderPropriedade = () => {
    venderCota(false, 0, cotaUsuarioId.current);
  };

  interface OnClickParams {
    key: string;
    cotaUsuarioId: string; // ou o tipo que for adequado
    numeroCota: string;
    empreend: string;
  }

  const navigate = useNavigate();

  const abrirDetalhesDaPropriedade = async (idCotaUsuario: number) => {
    try {
      const cadastro = await cadastroCotaUsuarioApi.buscarPorCotaUsuario(
        idCotaUsuario
      );
      const cadastroConcluido =
        Boolean(cadastro.concluidoEm) || cadastro.etapaAtual === "CONCLUIDO";

      if (!cadastroConcluido) {
        navigate(`/cadastroPropriedade/${cadastro.id}`);
        return;
      }
    } catch (erro: any) {
      // Sem um cadastro em andamento, a cota deve abrir seus detalhes, não o onboarding.
      if (erro?.response?.status !== 404) {
        error("Não foi possível abrir os detalhes da propriedade.");
        return;
      }
    }

    navigate(`/cadastroPropriedade/detalhes/${idCotaUsuario}`);
  };

  const onClick = async ({
    key,
    cotaUsuarioIdModal,
    numeroCotaModal,
    empreendModal,
    usuarioLogadoIdModal,
  }: any) => {
    const Token = validateToken();
    const perfil = Token?.nda;

    const periodoUsuarioId = periodoUsuario.current;
    if (
      periodoUsuarioId === 0 &&
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "1":
          await abrirDetalhesDaPropriedade(
            Number(cotaUsuarioId.current || cotaUsuarioIdModal)
          );

          break;
        case "2":
          localStorage.removeItem("filtrosDispPeriodo");
          localStorage.removeItem("pageDispPeriodo");

          switch (status.current) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
            case "AGUARDANDO_COTA":
            case "AGUARDANDO_DEFINICAO_ANUNCIO":
              error(
                "O cadastro da propriedade está pendente. Favor finalizar!"
              );
              break;
            default:
              document.location.href = `/disponibilizacaoPeriodos/?cotaUsuarioId=${
                cotaUsuarioId.current || cotaUsuarioIdModal
              }&&ncota=${numeroCota.current || numeroCotaModal}&&empreend=${
                empreend.current || empreendModal
              }`;
          }

          break;

        case "3":
          info();
          break;
        case "4":
          //Ver documentos
          document.location.href = `/gerenciarDocumentosProprietarios/?cotaUsuarioId=${
            cotaUsuarioId.current || cotaUsuarioIdModal
          }`;

          break;
        case "5":
          //error("Em desenvolvimento!");
          document.location.href = `/infoEmpreendimento/?empreend=${
            empreend.current || empreendModal
          }`;
          break;
        case "6":
          error(
            "Não é possível excluir essa propriedade. Qualquer dúvida, favor, entrar em contato conosco."
          );

          break;

        case "7":
          const resultPagamento = await verificarPagamentoPorStatus(
            "ATIVA",
            cotaUsuarioId.current || cotaUsuarioIdModal
          );
          if (resultPagamento) {
            warning("Sua propriedade já está sendo anunciada.");
            setTimeout(() => {
              navigate("/gerenciarAnuncioVenda", {
                state: {
                  cotaUsuarioId: cotaUsuarioId.current || cotaUsuarioIdModal,
                  nome: empreend.current || empreendModal,
                  usuarioId: usuarioLogadoId.current || usuarioLogadoIdModal,
                },
              });
            }, 3000);
          } else {
            const resultPagamentoPendente = await verificarPagamentoPorStatus(
              "PENDENTE",
              cotaUsuarioId.current || cotaUsuarioIdModal
            );
            if (resultPagamentoPendente) {
              warning(
                "Existe um pagamento aguardando confirmação. Qualquer dúvida entre em contato conosco."
              );
            } else {
              const formData = {
                usuarioId: usuarioLogadoId.current || usuarioLogadoIdModal,
                cotasUsuariosId: cotaUsuarioId.current || cotaUsuarioIdModal,
                planoAssinatura: "ANUNCIO_PROPRIEDADE",
              };

              const resultadoAssinatura = criarAssinaturaCTU(formData);

              if (await resultadoAssinatura) {
                let formData = {
                  status: "AGUARDANDO_MAISINFO_ANUNCIO",
                };
                const resultadoAtualizarCTU = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId.current || cotaUsuarioIdModal,
                  formData
                );
                if (await resultadoAtualizarCTU) {
                  document.location.href = `${Globais.LINK_PAGAMENTO}`;
                } else {
                  error("Há algo de errado. VCC-003");
                }
              } else {
                error("Há algo de errado. VCC-004");
                return false;
              }
            }
          }
          break;
      }
    }
  };

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    console.log("params", pagination, filters, sorter, extra);
    setFilteredInfo({
      empreend: filters.empreend,
      nomeCidade: filters.nomeCidade,
      numeroCota: filters.numeroCota,
      aptoNome: filters.aptoNome,
      icone: filters.icone,
    });

    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageCadastroCotas", page);
    }

    localStorage.setItem("filtrosCadastroCotas", JSON.stringify(filters));
    setSemFiltros(false);
  };
  const handleFilter = () => {
    localStorage.removeItem("filtrosCadastroCotas");
    localStorage.removeItem("pageCadastroCotas");
    setSemFiltros(true);
    document.location.reload();
  };

  // const isMobile = useMediaQuery("(max-width: 768px)");
  // const isDesktop = useMediaQuery("(min-width: 769px)");

  // State de abertura e fechamento do modal excluir assinatura
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedData, setSelectedData] = useState<any>({
    cotaUsuarioId: null,
    numeroCota: null,
    empreend: null,
    status: null,
  });

  const showModal = (data: any) => {
    setSelectedData(data); // Define os dados da linha selecionada
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal excluir assinatura
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  const handleButtonClick = () => {
    // Simula o clique no menu com uma key específica
    onClick({ key: "1" } as any);
  };

  return (
    <>
      {erroCarregamento && <Alert type="warning" showIcon message={erroCarregamento} />}
      {isLoading ? (
        <Skeleton active />
      ) : isDesktop ? (
        <Container>
          {contextHolder}
          <Row>
            <Col span={3}>
              <Flex align="end" justify="center" style={{ marginTop: 30 }}>
                <a href={`/inicio`}>
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title style={{ marginLeft: 10 }} level={3}>
                  Minhas Propriedades
                </Title>
              </Flex>
            </Col>
            <Col span={3}>
              <Button
                onClick={() =>
                  (document.location.href = "/cadastroPropriedade/v2")
                }
                type="primary"
                style={{ marginTop: 30 }}
              >
                Adicionar
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Flex
                align="start"
                justify="center"
                style={{ width: "100%", overflow: "auto" }}
              >
                <Table
                  columns={columns}
                  dataSource={visualizacaoCotas}
                  locale={{ emptyText: "Você ainda não possui propriedades cadastradas" }}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Container>
      ) : isMobile ? (
        <Container>
          <Row>
            {contextHolder}
            <Col span={3}>
              <Flex
                align="end"
                justify="center"
                style={{
                  marginTop: 35,
                }}
              >
                <a href={`/inicio`}>
                  <ArrowBackIcon style={{ color: "#003644" }} />
                </a>
              </Flex>
            </Col>
            <Col span={18}>
              <Flex align="center" justify="center">
                <HomeIcon
                  style={{ color: "#003644", marginTop: 20 }}
                  fontSize="large"
                />
                <Title style={{ marginLeft: 10 }} level={4}>
                  Minhas Propriedades
                </Title>
              </Flex>
            </Col>
          </Row>

          {visualizacaoCotas.length === 0 && <Empty description="Você ainda não possui propriedades cadastradas" />}
          <div
            style={{
              width: "100%",
              paddingBottom: "calc(7rem + env(safe-area-inset-bottom))",
            }}
          >
          {visualizacaoCotas.map(
            (row: any) => (
              console.log("row", row.numeroCota),
              (
                <Row
                  key={row.key}
                  style={{
                    width: "100%",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Col span={24}>
                    <details
                      style={{
                        width: "100%",
                        borderBottom: "3px solid #C3CDC7",
                      }}
                    >
                      <summary
                        style={{
                          width: "100%",
                          padding: "10px 15px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          textAlign: "left",
                        }}
                      >
                        <div
                            style={{
                              width: "100%",
                              minWidth: 0,
                              flexDirection: "column",
                              gap: 4,
                              display: "flex",
                              fontSize: "16px",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                flex: "1",
                                textAlign: "left",
                                whiteSpace: "normal",
                              }}
                            >
                              {row.empreend}
                            </span>
                            <span
                              style={{
                                textAlign: "right",
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                              }}
                            >
                              Nº Cota: {row.numeroCota}
                            </span>
                        </div>
                      </summary>
                        <ContainerItems>
                          <Items>
                            <strong>Cidade:</strong>{" "}
                            <Icon>{row.nomeCidade}</Icon>
                          </Items>
                          <Items>
                            <strong>Nº Cota:</strong>
                            <Icon>{row.numeroCota}</Icon>
                          </Items>
                          <Items>
                            <strong>Apartamento:</strong>
                            <Icon>{row.aptoNome}</Icon>
                          </Items>
                          <Items>
                            <strong>Data de cadastro:</strong>
                            <Icon>{row.created_at ? formatarData(row.created_at) : "Não definida"}</Icon>
                          </Items>
                          <Items style={{ gridColumn: "1 / -1", flexWrap: "wrap" }}>
                            <strong>Status:</strong>
                            <Icon>
                              {row.cadastroCotaUsuarioId && <PendingActionsIcon color="warning" aria-label="Cadastro em andamento" />}
                              {row.icone}
                            </Icon>
                          </Items>
                          <Items style={{ gridColumn: "1 / -1", justifyContent: "center" }}>
                            <Flex align="center" justify="center">
                              <Button
                                onClick={() => row.cadastroCotaUsuarioId
                                  ? navigate(`/cadastroPropriedade/${row.cadastroCotaUsuarioId}`)
                                  : showModal({
                                    cotaUsuarioId: row.cotaUsuarioId,
                                    numeroCota: row.numeroCota,
                                    empreend: row.empreend,
                                    status: row.situacao,
                                  })
                                }
                                type="primary"
                                style={{
                                  marginTop: 30,
                                  backgroundColor: "#003644",
                                  borderColor: "#003644",
                                  color: "white",
                                }}
                              >
                                {row.cadastroCotaUsuarioId ? "Continuar cadastro" : "Ações"}
                              </Button>
                            </Flex>
                          </Items>
                        </ContainerItems>
                    </details>
                  </Col>
                </Row>
              )
            )
          )}
          </div>

          <Row
            style={{
              position: "fixed",
              bottom: "4rem", // Distância do rodapé
              right: "3rem", // Distância da borda direita
              zIndex: 1000, // Garante que o botão fique acima de outros elementos
            }}
          >
            <Col span={14}></Col>
            <Col span={10}>
              <Fab
                color="primary"
                aria-label="add"
                onClick={() =>
                  (document.location.href = "/cadastroPropriedade/v2")
                }
              >
                <AddIcon />
              </Fab>
            </Col>
          </Row>

          <ModalAcoes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            onClick={onClick}
            cotaUsuarioId={selectedData.cotaUsuarioId}
            numeroCota={selectedData.numeroCota}
            empreend={selectedData.empreend}
            status={selectedData.status}
            usuarioLogadoId={usuarioLogadoId.current}
            selectedRowKeys={selectedRowKeys} // Substitua com o valor real
            emLote={emLote.current} // Substitua com o valor real
          />
        </Container>
      ) : null}
    </>
  );
}
